<template>
    <div class="page-cookies" v-if="show">
        <div class="cookies-notification">
            <div class="page-cookies__container">

                <div class="cookies">
                    <div class="cookies__text">
                        <p v-html="cookie.cookieDisclaimer"></p>
                    </div>
                    <div class="cookies__shape">
                        <button class="button--ghost-simple" @click.prevent="close">
                            Sluit
                        </button>
                    </div>
                </div>

            </div>
        </div>

        <div class="cookies-settings">
            <div class="page-cookies__container">
                <p class="cookies-settings__heading">Cookie instellingen</p>
                <div class="cookie-settings__wrapper">
                    <div class="cookies-settings__item-wrapper">
                        <!--<div class="cookies-settings__item">-->
                            <!--<label class="cookies-settings__radio">-->
                                <!--<input type="checkbox" class="cookies-settings__checkbox" v-model="greeneryAdvancedCookie">-->
                                <!--<span class="cookies-settings__checkmark">✔</span>-->
                            <!--</label>-->
                            <!--<p class="cookies-settings__text">{{cookie.cookieAdvanced}}</p>-->
                        <!--</div>-->

                        <div class="cookies-settings__item">
                            <label class="cookies-settings__radio cookies-settings__radio--disabled">
                                <input type="checkbox" class="cookies-settings__checkbox" checked="checked" v-model="greeneryDefaultCookie">
                                <span class="cookies-settings__checkmark">✔</span>
                            </label>

                            <p class="cookies-settings__text">{{cookie.cookieDefault}}</p>
                        </div>
                    </div>
                    <div class="cookies-settings__button-wrapper">
                        <button class="button--ghost-simple  button--ghost-simple--active" @click.prevent="close">Bevestig</button>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    import Cookies from 'js-cookie';

    export default {
        props: ['cookie'],

        data() {
            return {
                show: true,
                greeneryDefaultCookie: true,
                // greeneryAdvancedCookie: true,
            };
        },

        methods: {
            showSettings() {
                document.querySelector('.cookies-settings').style.transform = 'translateY(-100%)';
            },

            setCookies() {
                // Cookies.remove('greeneryAdvancedCookie', { path: '/' });
                Cookies.set('greeneryDefaultCookie', 'true', { expires: 365 });

                // if (this.greeneryAdvancedCookie) {
                //     Cookies.set('greeneryAdvancedCookie', 'true', { expires: 365 });
                // }

                window.dataLayer.push({ event: 'cookie consent' });
            },

            close() {
                this.setCookies();
                this.show = false;
            },
        },

        mounted() {
            if(document.querySelector('.js-cookie-settings')) {
                document.querySelector('.js-cookie-settings').addEventListener('click', this.showSettings.bind(this));
            }

            if (Cookies.get('greeneryDefaultCookie')) {
                this.show = false;
            } else {
                this.setCookies();
            }
        },
    };
</script>
